import { chartColors } from 'styles/configs/chartColors';

// For now we are using the same color (but dashed) for comparisons. Left parameter as might get resurrected
export const getChartColor = (idx: number, _isComparison = false) => chartColors.multiChart[idx];

export const getChartColorWithMax = (idx: number, max = 11) => {
  if (idx < max) {
    return chartColors.multiChart[idx];
  }
  return getOthersColor();
};

export const getOthersColor = () => chartColors.multiChart[14];
